// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Region } from './Region';
import {
  RegionFromJSON,
  RegionFromJSONTyped,
  RegionToJSON,
  RegionToJSONTyped,
} from './Region';

/**
 *
 * @export
 * @interface Regions
 */
export interface Regions {
  /**
   *
   * @type {Array<Region>}
   * @memberof Regions
   */
  aws: Array<Region>;
  /**
   *
   * @type {Array<Region>}
   * @memberof Regions
   */
  azure: Array<Region>;
  /**
   *
   * @type {Array<Region>}
   * @memberof Regions
   */
  gcp: Array<Region>;
}

/**
 * Check if a given object implements the Regions interface.
 */
export function instanceOfRegions(value: object): value is Regions {
  if (!('aws' in value) || value['aws'] === undefined) return false;
  if (!('azure' in value) || value['azure'] === undefined) return false;
  if (!('gcp' in value) || value['gcp'] === undefined) return false;
  return true;
}

export function RegionsFromJSON(json: any): Regions {
  return RegionsFromJSONTyped(json, false);
}

export function RegionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Regions {
  if (json == null) {
    return json;
  }
  return {
    aws: (json['aws'] as Array<any>).map(RegionFromJSON),
    azure: (json['azure'] as Array<any>).map(RegionFromJSON),
    gcp: (json['gcp'] as Array<any>).map(RegionFromJSON),
  };
}

export function RegionsToJSON(json: any): Regions {
  return RegionsToJSONTyped(json, false);
}

export function RegionsToJSONTyped(
  value?: Regions | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws: (value['aws'] as Array<any>).map(RegionToJSON),
    azure: (value['azure'] as Array<any>).map(RegionToJSON),
    gcp: (value['gcp'] as Array<any>).map(RegionToJSON),
  };
}
